import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import winnerSuccess from '../../assets/winner-success.svg';
import gift from '../../assets/gift.svg';
import travel from '../../assets/travel.svg';

const FormSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const decodeUTF8 = (str) => {
    return decodeURIComponent(escape(window.atob(str)));
  };

  const auction = decodeUTF8(searchParams.get('title'));
  const rewardType = decodeUTF8(searchParams.get('rewardType'));

  const handleClic = () => {
    navigate('/');
  };

  return (
    <div className="bg-white">
      <Container className="py-30 py-sm-60">
        <Row className="ml-md-5">
          <Col md={8} className="ml-md-3 text-center order-2 order-md-1">
            <h2 className="mb-4 text-secondary f-600-bold text-tangaroa">¡Gracias por confirmar tus datos!</h2>
            <p className="lh-27 ft-18 text-tangaroa">Pronto nos pondremos en contacto contigo para hacer entrega de tu premio. Te pedimos estés al pendiente de tu correo electrónico y número telefónico registrados.</p>

            <img src={winnerSuccess} className="img-fluid" alt="Winners" />

            <p className="alternate text-tangaroa f-600">Haz clic en el botón de ‘Salir’ para continuar navegando en el sitio.</p>

            <div className="d-block mt-4">
              <button type="button" className="btn btn-primary" onClick={handleClic}>
                Salir
              </button>
            </div>
          </Col>

          <Col md={3} className="order-1 order-md-2 mb-30 mb-md-0">
            <div className="bg-alabaster bd-alabaster p-3 bdr-5 d-flex flex-row flex-sm-column">
              {rewardType === 'PRODUCT'
                ? (
                  <img src={gift} className="w-25 mb-3" alt="Gift" />
                ) : (
                  <img src={travel} className="w-25 mb-3" alt="Gift" />
                )}
              <h4 className="text-tangaroa font-weight-bold ml-15 ml-sm-0">{auction}</h4>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default FormSuccess;
